import { decodeJwtClaims, getAccessToken, getJwtUserId } from "./securityUtil.js";

export function getSessionContext() {
  // country & language
  const countryEl = document.getElementById("country-select");
  const languageEl = document.getElementById("language-select");

  const countryId = countryEl ? countryEl.value : null;
  const languageId = languageEl ? languageEl.value : null;

  // JWT
  const token = getAccessToken();
  if (!token) return null;

  const payload = decodeJwtClaims(token);
  if (!payload) return null;

  return {
    countryId,
    languageId,
    userId: getJwtUserId(payload),
    projectId: payload.projectID || payload.projectId || payload.project_id
  };
}
